import { BlogPost, BlogCategory, estimateReadingTime } from './types';
import buildingFriendships from './posts/how-to-make-friends-as-a-childfree-couple';
import dinkStatistics from './posts/how-many-dink-couples-in-the-us';
import dinkEconomy from './posts/the-dink-economy-explained';
import bestCities from './posts/best-cities-for-childfree-couples';
import adultsOnlyTravel from './posts/adults-only-travel-guide';
import childfreeLoneliness from './posts/childfree-loneliness';
import nationalPetDay from './posts/national-pet-day-dink-couples';
import digitalNomadCouple from './posts/childfree-digital-nomad-couple';
import whyChildfreeRising from './posts/why-more-adults-choosing-childfree';
import makingFriendsIn30s from './posts/making-friends-in-your-30s-childfree';
import dinkFire from './posts/dink-fire-financial-independence';
import regretResearch from './posts/do-people-regret-not-having-kids';

// Add reading time to all posts
function withReadingTime(post: BlogPost): BlogPost {
  return {
    ...post,
    readingTime: post.readingTime ?? estimateReadingTime(post.content),
  };
}

export const allPosts: BlogPost[] = [
  buildingFriendships,
  dinkStatistics,
  dinkEconomy,
  bestCities,
  adultsOnlyTravel,
  childfreeLoneliness,
  nationalPetDay,
  digitalNomadCouple,
  whyChildfreeRising,
  makingFriendsIn30s,
  dinkFire,
  regretResearch,
]
  .map(withReadingTime)
  .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());

export function getPostBySlug(slug: string): BlogPost | undefined {
  return allPosts.find((p) => p.slug === slug);
}

export function getLatestPosts(count: number = 3): BlogPost[] {
  return allPosts.slice(0, count);
}

export function getPostsByCategory(category: BlogCategory): BlogPost[] {
  return allPosts.filter((p) => p.categories.includes(category));
}
